import { startOfDay } from 'date-fns';
import {
  BooleanParam,
  DateParam,
  NumberParam,
  NumericArrayParam,
  withDefault,
} from 'react-router-url-params';

export const calendarParams = {
  currentDay: withDefault(DateParam, startOfDay(new Date())),
  configurationId: withDefault(NumberParam, undefined),
  appointmentTypes: withDefault(NumericArrayParam, [] as number[]),
  subtenants: withDefault(NumericArrayParam, [] as number[]),
  doctors: withDefault(NumericArrayParam, [] as number[]),
  visitTypes: withDefault(NumericArrayParam, [] as number[]),
  places: withDefault(NumericArrayParam, [] as number[]),
  specialConditions: withDefault(NumericArrayParam, [] as number[]),
  tags: withDefault(NumericArrayParam, [] as number[]),
  visitStatuses: withDefault(NumericArrayParam, [] as number[]),
  isFilterDisplayed: withDefault(BooleanParam, true),
};
